<template>
  <div v-show="loaded" class="container">
    <div v-if="viper==0" class="vip_un">
      <img class="vip_top" src="../../assets/images/fl20210204/vipban.png" />
      <div class="vip_tabs">
        <div class="vip_tabs_title">斐燃会员级别</div>
        <div @click="viperUserRules()" class="vip_tabs_stitle">
          会员使用细则
          <img src="../../assets/images/fl20210204/vip_righrt_icon.png" />
        </div>
        <div class="vip_tabs_list">
          <div @click="VipUnSelect('A')" :class="[{'vip_tabs_itemS':vip_un_curCard=='A'},'vip_tabs_item vip_tabs_item_A']">
            <div class="vip_tabs_item_title">黄金</div>
            <div class="vip_tabs_item_stitle">¥288</div>
            <div v-show="vip_un_curCard=='A'" class="vip_tabs_item_current">当前</div>
          </div>
          <div @click="VipUnSelect('B')" :class="[{'vip_tabs_itemS':vip_un_curCard=='B'},'vip_tabs_item vip_tabs_item_B']">
            <div class="vip_tabs_item_title">铂金</div>
            <div class="vip_tabs_item_stitle">¥1188</div>
            <div v-show="vip_un_curCard=='B'" class="vip_tabs_item_current">当前</div>
          </div>
          <div @click="VipUnSelect('C')" :class="[{'vip_tabs_itemS':vip_un_curCard=='C'},'vip_tabs_item vip_tabs_item_C']">
            <div class="vip_tabs_item_title">钻石</div>
            <div class="vip_tabs_item_stitle">¥3888</div>
            <div v-show="vip_un_curCard=='C'" class="vip_tabs_item_current">当前</div>
          </div>
          <div @click="VipUnSelect('D')" :class="[{'vip_tabs_itemS':vip_un_curCard=='D'},'vip_tabs_item vip_tabs_item_D']">
            <div class="vip_tabs_item_title">黑金</div>
            <div class="vip_tabs_item_stitle">¥18888</div>
            <div v-show="vip_un_curCard=='D'" class="vip_tabs_item_current">当前</div>
            <div class="vip_tabs_item_limite">限量</div>
          </div>
          <!-- <img style="width: 5rem;margin-top: -0.5625rem;border: 1px solid red;" src="http://img.unionfit.cn/blackicon.png" /> -->
          <!-- <wx-open-launch-weapp id="launch-btn" username="gh_9f895bb61a7d" path="pages/fb_index/fb_index.html">
            <script type="text/wxtag-template">
              <style>
                .vip_tabs_item_img{
                  width: 5rem;
                  margin-top: -0.5625rem;
                }
              </style>
              <img class="vip_tabs_item_img" src="http://img.unionfit.cn/blackicon.png" />
            </script>
          </wx-open-launch-weapp> -->
          <!--  -->
          <div class="clearboth"></div>
        </div>
      </div>
      <div class="vip_desc">
        <img class="vip_desc_img" src="../../assets/images/fl20210204/vipbg.png" />
        <div class="vip_desc_txt">
          <div v-show="vip_un_curCard=='A'">
            <div class="vip_desc_txt_title">
              <label class="vip_desc_txt_titleL">5</label>折门市价
              <!-- <label class="vip_desc_txt_titleN"> </label> -->
            </div>
            <div class="vip_desc_txt_stitle">会员专享门市价5折/次</div>
            <div class="vip_desc_txt_stitles">每周运动1次，1年至少省<label> 12200 </label>元</div>
          </div>

          <div v-show="vip_un_curCard=='B'">
            <div class="vip_desc_txt_title">
              <label class="vip_desc_txt_titleL">5</label>折门市价 + <label class="vip_desc_txt_titleL">12</label>次免费权益
            </div>
            <div class="vip_desc_txt_stitle">会员专享门市价5折/次，12次免费抵扣权益（每月一次）</div>
            <div class="vip_desc_txt_stitles">每周运动1次，1年至少省<label> 13600 </label>元</div>
          </div>

          <div v-show="vip_un_curCard=='C'">
            <div class="vip_desc_txt_title">
              <label class="vip_desc_txt_titleL">5</label>折门市价 + <label class="vip_desc_txt_titleL">52</label>次免费权益
            </div>
            <div class="vip_desc_txt_stitle">会员专享门市价5折/次，52次免费抵扣权益（每周一次）</div>
            <div class="vip_desc_txt_stitles">每周运动1次，1年至少省<label> 15400 </label>元</div>
          </div>

          <div v-show="vip_un_curCard=='D'">
            <div class="vip_desc_txt_title">
              <label class="vip_desc_txt_titleLB">当天预约，想订就订</label>
            </div>
            <div class="vip_desc_txt_stitle">黑金专享一口价88元，365次免费抵扣权益（每日一次）</div>
            <div class="vip_desc_txt_stitles">每周运动1次，1年至少省<label> 27400 </label>元</div>
          </div>

          <img v-show="vip_un_curCard=='D'" class="vip_desc_txt_blackicon" src="http://img.unionfit.cn/wxxcx_hjzstd.png" />
        </div>
      </div>
      <div class="vip_tb">
        <div class="vip_tb_title">
          <label class="vip_tb_title_left"></label>
          会员权益对比
          <label class="vip_tb_title_right"></label>
        </div>
        <div class="vip_tb_item">
          <div class="vip_tb_item_title">免费权益</div>
          <div class="vip_tb_item_block">
            <div :class="[{'vip_tb_item_block_itemA':vip_un_curCard=='A'},'vip_tb_item_block_item']">无</div>
            <div :class="[{'vip_tb_item_block_itemB':vip_un_curCard=='B'},'vip_tb_item_block_item']">12次</div>
            <div :class="[{'vip_tb_item_block_itemC':vip_un_curCard=='C'},'vip_tb_item_block_item']">52次</div>
            <div :class="[{'vip_tb_item_block_itemD':vip_un_curCard=='D'},'vip_tb_item_block_itemF']">每天1次</div>
            <div class="clearboth"></div>
          </div>
        </div>

        <div class="vip_tb_item">
          <div class="vip_tb_item_title">会员价格</div>
          <div class="vip_tb_item_block">
            <div :class="[{'vip_tb_item_block_itemA':vip_un_curCard=='A'},'vip_tb_item_block_item']">门市价<br>5折</div>
            <div :class="[{'vip_tb_item_block_itemB':vip_un_curCard=='B'},'vip_tb_item_block_item']">门市价<br>5折</div>
            <div :class="[{'vip_tb_item_block_itemC':vip_un_curCard=='C'},'vip_tb_item_block_item']">门市价<br>5折</div>
            <div :class="[{'vip_tb_item_block_itemD':vip_un_curCard=='D'},'vip_tb_item_block_itemF']">一口价<br>88元</div>
            <div class="clearboth"></div>
          </div>
        </div>

        <div class="vip_tb_item">
          <div class="vip_tb_item_title">生日福利</div>
          <div class="vip_tb_item_block">
            <div :class="[{'vip_tb_item_block_itemA':vip_un_curCard=='A'},'vip_tb_item_block_item']">88元<br>抵用券</div>
            <div :class="[{'vip_tb_item_block_itemB':vip_un_curCard=='B'},'vip_tb_item_block_item']">1次<br>权益券</div>
            <div :class="[{'vip_tb_item_block_itemC':vip_un_curCard=='C'},'vip_tb_item_block_item']">1次<br>权益券</div>
            <div :class="[{'vip_tb_item_block_itemD':vip_un_curCard=='D'},'vip_tb_item_block_itemF']">自助下午茶/<br>午餐双人券</div>
            <div class="clearboth"></div>
          </div>
        </div>

        <div class="vip_tb_item">
          <div class="vip_tb_item_title">酒店列表</div>
          <div class="vip_tb_item_block">
            <div @click="toallstadiumlist(1)" :class="[{'vip_tb_item_block_itemA':vip_un_curCard=='A'},'vip_tb_item_block_item  vip_tb_item_block_item_line']">酒店<br>名单</div>
            <div @click="toallstadiumlist(2)" :class="[{'vip_tb_item_block_itemB':vip_un_curCard=='B'},'vip_tb_item_block_item  vip_tb_item_block_item_line']">酒店<br>名单</div>
            <div @click="toallstadiumlist(3)" :class="[{'vip_tb_item_block_itemC':vip_un_curCard=='C'},'vip_tb_item_block_item  vip_tb_item_block_item_line']">酒店<br>名单</div>
            <div @click="toallstadiumlist(4)" :class="[{'vip_tb_item_block_itemD':vip_un_curCard=='D'},'vip_tb_item_block_itemF vip_tb_item_block_item_line']">全部<br>酒店</div>
            <div class="clearboth"></div>
          </div>
        </div>

        <div class="vip_tb_item">
          <div class="vip_tb_item_title">游泳健身服务——预约保障</div>
          <div class="vip_tb_item_block">
            <div :class="[{'vip_tb_item_block_itemA':vip_un_curCard=='A'},'vip_tb_item_block_item']">提前1天<br>预约</div>
            <div :class="[{'vip_tb_item_block_itemB':vip_un_curCard=='B'},'vip_tb_item_block_item']">提前1天<br>预约</div>
            <div :class="[{'vip_tb_item_block_itemC':vip_un_curCard=='C'},'vip_tb_item_block_item']">提前1天<br>预约</div>
            <div :class="[{'vip_tb_item_block_itemD':vip_un_curCard=='D'},'vip_tb_item_block_itemF']">18点前-提前<br>2小时预约</div>
            <div class="clearboth"></div>
          </div>
        </div>

        <div class="vip_tb_item">
          <div class="vip_tb_item_title">游泳健身服务——退订保障</div>
          <div class="vip_tb_item_block">
            <div :class="[{'vip_tb_item_block_itemA':vip_un_curCard=='A'},'vip_tb_item_block_item']">提前24小<br>时退订</div>
            <div :class="[{'vip_tb_item_block_itemB':vip_un_curCard=='B'},'vip_tb_item_block_item']">提前24小<br>时退订</div>
            <div :class="[{'vip_tb_item_block_itemC':vip_un_curCard=='C'},'vip_tb_item_block_item']">提前24小<br>时退订</div>
            <div :class="[{'vip_tb_item_block_itemD':vip_un_curCard=='D'},'vip_tb_item_block_itemF']">提前2小<br>时退订</div>
            <div class="clearboth"></div>
          </div>
        </div>

        <div class="vip_tb_item">
          <div class="vip_tb_item_title">瑜伽课程服务——预约保障</div>
          <div class="vip_tb_item_block">
            <div :class="[{'vip_tb_item_block_itemA':vip_un_curCard=='A'},'vip_tb_item_block_item']">提前3小<br>时预约</div>
            <div :class="[{'vip_tb_item_block_itemB':vip_un_curCard=='B'},'vip_tb_item_block_item']">提前3小<br>时预约</div>
            <div :class="[{'vip_tb_item_block_itemC':vip_un_curCard=='C'},'vip_tb_item_block_item']">提前3小<br>时预约</div>
            <div :class="[{'vip_tb_item_block_itemD':vip_un_curCard=='D'},'vip_tb_item_block_itemF']">提前3小<br>时预约</div>
            <div class="clearboth"></div>
          </div>
        </div>

        <div class="vip_tb_item">
          <div class="vip_tb_item_title">瑜伽课程服务——退订保障</div>
          <div class="vip_tb_item_block">
            <div :class="[{'vip_tb_item_block_itemA':vip_un_curCard=='A'},'vip_tb_item_block_item']">提前3小<br>时退订</div>
            <div :class="[{'vip_tb_item_block_itemB':vip_un_curCard=='B'},'vip_tb_item_block_item']">提前3小<br>时退订</div>
            <div :class="[{'vip_tb_item_block_itemC':vip_un_curCard=='C'},'vip_tb_item_block_item']">提前3小<br>时退订</div>
            <div :class="[{'vip_tb_item_block_itemD':vip_un_curCard=='D'},'vip_tb_item_block_itemF']">提前3小<br>时退订</div>
            <div class="clearboth"></div>
          </div>
        </div>

        <div class="vip_tb_item">
          <div class="vip_tb_item_title">客服服务</div>
          <div class="vip_tb_item_block">
            <div :class="[{'vip_tb_item_block_itemA':vip_un_curCard=='A'},'vip_tb_item_block_item']">客服<br>专线</div>
            <div :class="[{'vip_tb_item_block_itemB':vip_un_curCard=='B'},'vip_tb_item_block_item']">客服<br>专线</div>
            <div :class="[{'vip_tb_item_block_itemC':vip_un_curCard=='C'},'vip_tb_item_block_item']">客服<br>专线</div>
            <div :class="[{'vip_tb_item_block_itemD':vip_un_curCard=='D'},'vip_tb_item_block_itemF']">一对一<br>客服专线</div>
            <div class="clearboth"></div>
          </div>
        </div>

      </div>
      <div :class="[{'vip_buyH':isphone},'vip_buy']">
        <!-- isphone -->
        <div v-show="vip_un_curCard=='A'||vip_un_curCard=='B'||vip_un_curCard=='C'" @click="VipReadProtol()" class="vip_buy_protol">
          <img :src="vip_protol_agree_icon" />
          已阅读并同意<label>《斐燃会员开通协议》</label>
        </div>
        <div v-show="vip_un_curCard=='D'" @click="VipReadProtolB()" class="vip_buy_protol">
          <img :src="vip_protol_agree_iconB" />
          已阅读并同意<label>《斐燃黑金会员开通协议》</label>
        </div>

        <div @click="BuyCard()" v-show="vip_un_curCard=='A'||vip_un_curCard=='B'||vip_un_curCard=='C'" class="vip_buy_btn">
          <div :class="[{'vip_buy_btn_deleeteF':iphone==false},'vip_buy_btn_deleete']" v-show="coupon_list.length>0">¥{{current_card_price}}</div>
          <div :class="[{'vip_buy_btn_priceF':iphone==false},'vip_buy_btn_price']">
            <!--  -->
            &nbsp;¥{{fl_final_price}} 立即开通
          </div>

          <img v-show="coupon_list.length>0" src="../../assets/images/fl20210204/vipdiscounticon.png" />
        </div>
        <!-- <div @click="BuyCardBlack()" v-show="vip_un_curCard=='D'" class="vip_buy_btn">
          ¥18888
          立即开通
        </div> -->

        <div class="vip_buy_btnB" v-show="vip_un_curCard=='D'" style="">
          <img v-show="bCouponPrice==18000" src="../../assets/images/fl20210204/vipdiscounticon.png" />
          <div v-show="bCouponPrice==18000" class="vip_buy_btnB_deleete">¥18888</div>
          ¥{{bCouponPrice}} 立即开通
          <div @click="showBlackCode()" class="vip_buy_btnitem">
            <wx-open-launch-weapp
              id="launch-btn"
              username="gh_9f895bb61a7d"
              path="pages/fb_index/fb_index.html"
            >
              <script type="text/wxtag-template">
                <style>.btn { width: 750px;height: 60px;outline: none;padding: 0;margin: 0;background: none;}</style>
                <button class="btn"></button>
              </script>
            </wx-open-launch-weapp>
          </div>

        </div>
        <!-- <wx-open-launch-weapp id="launch-btn" username="gh_9f895bb61a7d" path="pages/fb_index/fb_index.html">
          <script>
            <style>
              .btn {
                width: 100%;
                border: none;
                outline: none;
                padding: 0;
                margin: 0;
                background: linear-gradient(139deg, #0A0A0A 0%, #4B3D31 100%);
                font-size: 20px;
                height: 55px;
                color: #FFFFFF;
                text-align: center;
               }
            </style>
            <button class="btn">
              ¥18888　立即开通
            </button>
          </script>
        </wx-open-launch-weapp> -->
      </div>
    </div>

    <div v-else class="vip_is">
      <div class="viper_title">您好，尊贵的斐燃{{card_name}}会员</div>
      <div class="viper_swiper">
        <swiper :options="swiperOption" class="bb_vipBuyCard_swiper">
          <swiper-slide class="bb_vipBuyCard_swiper_slide" v-for="(item,index) in flswiper" :key="index">
            <img :src="item.thumb" class="bb_vipBuyCard_swiper_slide_cardbg" />
            <!-- <img v-show="item.sid==1003" class="bb_viptem_saleover" src="../../assets/images/base/saleover.png"> -->
            <div  class="fl_cupanel">
              <!-- <div class="fl_cupanel_msg1">{{item.msg_3}}</div>
              <div class="fl_cupanel_msg2">
                {{item.msg_1}}
                <div>{{(item.end_date).replace(/-/g,'.')}}到期</div>
              </div>
              <div v-if="item.bind_username" class="fl_cupanel_msg3">
                {{item.bind_username}}
                <div>NO. {{item.cards_no}}</div>
              </div>
              <div v-else class="fl_cupanel_msg3">
                {{item.msg_2}}
                <div>NO. {{item.cards_no}}</div>
              </div> -->
              <div :class="[{'fl_cupanel_msg3A':viper_current_obj.vip_tag=='A1'||viper_current_obj.vip_tag=='A2'},{'fl_cupanel_msg3B':viper_current_obj.vip_tag=='B1'||viper_current_obj.vip_tag=='B2'},{'fl_cupanel_msg3C':viper_current_obj.vip_tag=='C1'||viper_current_obj.vip_tag=='C2'},'fl_cupanel_msg3']">
                <!--  v-show="" -->
                {{item.msg_1}}
                <div>{{(item.end_date).replace(/-/g,'.')}}到期</div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div v-show="viper_index > 0" class="swiper-button-prev"></div>
        <div v-show="viper_index + 1 != flswiper.length" class="swiper-button-next"></div>
      </div>
      <img class="viper_line" src="../../assets/images/fl20210204/viper_line.png" />
      <div class="viper_list">
        <div class="viper_list_title">
          会员权益
          <!-- v-show="viper_current_obj.vip_tag=='B1'||viper_current_obj.vip_tag=='B2'||viper_current_obj.vip_tag=='C1'||viper_current_obj.vip_tag=='C2'" -->
          <div  v-show="viper_current_obj.free_times>0" @click="toVipBenefitLog()">
            <img class="viper_list_title_icon1" src="../../assets/images/fl20210204/viper_benefit_icon.png" />
            权益使用明细
            <img class="viper_list_title_icon2" src="../../assets/images/fl20210204/vip_righrt_icon.png" />
          </div>
        </div>
        <div class="viper_list_block">
          <div v-show="viper_current_obj.free_times==0" class="viper_list_itemL viper_list_icon1">
            <div class="viper_list_item_title viper_list_item_titles">免费权益</div>
            <div class="viper_list_item_stitle viper_list_item_stitleS">无次数</div>
          </div>
          <div v-show="viper_current_obj.free_times>0" @click="showVipBenefit(0,'fit')" class="viper_list_itemL viper_list_icon1">
            <div class="viper_list_item_title">免费权益</div>
            <div class="viper_list_item_stitle">{{viper_current_obj.free_times}}次权益</div>
          </div>



          <div @click="showVipBenefit(1,'fit')" class="viper_list_itemR viper_list_icon2">
            <div class="viper_list_item_title">会员价格</div>
            <!-- <div class="viper_list_item_stitle"></div> -->
            <div v-show="viper_current_obj.vip_tag=='A2'||viper_current_obj.vip_tag=='B2'||viper_current_obj.vip_tag=='C2'" class="viper_list_item_stitle">门市价5折</div>
            <div v-show="viper_current_obj.vip_tag=='A1'||viper_current_obj.vip_tag=='B1'||viper_current_obj.vip_tag=='C1'" class="viper_list_item_stitle">88元/次</div>

          </div>
          <div @click="showVipBenefit(4,'fit')" class="viper_list_itemL viper_list_icon3">
            <div class="viper_list_item_title">生日福利</div>
            <div v-show="viper_current_obj.free_times>0" class="viper_list_item_stitle">1次权益券</div>
            <div v-show="viper_current_obj.free_times==0" class="viper_list_item_stitle">88元抵用券/张</div>
          </div>
          <div class="viper_list_itemR viper_list_icon4">
            <div @click="tostadiumlist(0)" class="viper_list_item_title">精选酒店</div>
            <div @click="tostadiumlist(1)" class="viper_list_item_stitle">
              五星级酒店
              <!-- <label>查看</label> -->
            </div>
          </div>

          <div @click="showVipBenefit(1,'fit')" class="viper_list_itemL viper_list_icon5">
            <div class="viper_list_item_title">泳健预约</div>
            <div class="viper_list_item_stitle">提前1天预约</div>
          </div>
          <div @click="showVipBenefit(2,'fit')" class="viper_list_itemR viper_list_icon6">
            <div class="viper_list_item_title">泳健退订</div>
            <div class="viper_list_item_stitle">提前24小时退订</div>
          </div>
          <div @click="showVipBenefit(1,'yoga')" class="viper_list_itemL viper_list_icon7">
            <div class="viper_list_item_title">瑜伽预约</div>
            <div class="viper_list_item_stitle">提前3小时预约</div>
          </div>
          <div @click="showVipBenefit(2,'yoga')" class="viper_list_itemR viper_list_icon6">
            <div class="viper_list_item_title">瑜伽退订</div>
            <div class="viper_list_item_stitle">提前3小时退订</div>
          </div>
          <div class="clearboth"></div>

          <div @click="hotLine()" class="viper_list_hotline">会员专线：<label>400-630-5888</label></div>

        </div>
      </div>
      <div class="viper_stper">
        <img src="../../assets/images/FLVersion/vipstep.png" />
        <div @click="showCradUseRule()">查看会员使用规则</div>
      </div>

      <div @click="tostadiumlistm()" :class="[{'viper_btnH':isphone},'viper_btn']">立即预约</div>
    </div>

    <!-- <div v-if="viper==0 && sq_is_show" @click="qushenquan()" class="vip_customac">
      斐燃<br />神券
    </div> -->
    <div v-if="viper==0" @click="qimoCustomer()" class="vip_custom">
      客服<br />咨询
    </div>

    <van-popup v-model="popupShow" :close-on-click-overlay="false">
      <div class="vip_protol">
        <img @click="VIPClosePopup()" class="vip_protol_close" src="../../assets/images/FLVersion/fl_details_pop_close.png" />
        <div class="vip_protol_title" >斐燃会员开通协议</div>
        <div @scroll="FLScrollEvent" class="vip_protol_conte">
          <buyCardProtocol />
        </div>
        <div @click="VIPAgreeProtol()" :class="[{'vip_protol_btnS':vip_scroll_bottom==true},'vip_protol_btn']">确认已阅读并同意</div>
      </div>
    </van-popup>
    <van-popup v-model="popupShowB" :close-on-click-overlay="false">
      <div class="vip_protol">
        <img @click="VIPClosePopupB()" class="vip_protol_close" src="../../assets/images/FLVersion/fl_details_pop_close.png" />
        <div class="vip_protol_title" >斐燃黑金会员开通协议</div>
        <div @scroll="FLScrollEventB" class="vip_protol_conte">
          <buyCardProtocolB />
        </div>
        <div @click="VIPAgreeProtolB()" :class="[{'vip_protol_btnS':vip_scroll_bottomB==true},'vip_protol_btn']">确认已阅读并同意</div>
      </div>
    </van-popup>

    <van-popup v-model="popupShowCode" style="width: 75%;" >
      <div class="vip_blackCode">
        <img  src="../../assets/images/fl20210204/gh_9f895bb61a7d_258.jpg" />
        <div>长按进入斐燃黑金</div>
      </div>
    </van-popup>

  </div>
</template>

<script>
  import buyCardProtocol from '../subgroup/buyCardProtocol.vue'
  import buyCardProtocolB from '../subgroup/buyCardProtocolB.vue'
  import viperUseRules from '../subgroup/viperUseRules.vue'
  export default {
    components:{
      'buyCardProtocol':buyCardProtocol,
      'viperUseRules':viperUseRules,
      'buyCardProtocolB':buyCardProtocolB
    },
    data() {
      var _this = this
      return {
        loaded:false,//加载是否结束
        vip_un_curCard:'A',//A:黄金  B:铂金  C:钻石  D:黑金
        isphone:false,//判断是否为iphone
        popupShow:false,//弹框
        popupShowB:false,
        vip_scroll_bottom:false,//弹框购买协议滚动到底不
        vip_scroll_bottomB:false,
        vip_protol_agree:false,//是否同意购卡协议
        vip_protol_agreeB:false,
        vip_protol_agree_icon:'',//阅读icon
        vip_protol_agree_iconB:'',
        vip_protol_agree_no:require('../../assets/images/fl20210204/choose_agree_no.png'),//阅读icon no
        vip_protol_agree_yes:require('../../assets/images/fl20210204/choose_agree_yes.png'),//阅读icon yes

        viper:0,// 0 非会员  1 会员
        flswiper:[],// 我的会员卡
        viper_index:0,// 当前会员卡索引
        viper_current_obj:{},//当前会员卡
        coupon_list:[],//我的优惠券列表
        user_coupon_id:'',
        swiperOption: { // 有卡 swiper
          loop: false,
          autoplay: 5000,
          slidesPerView: "auto",
          centeredSlides: true,
          on: {
            slideChangeTransitionEnd: function() {
              console.log(this.activeIndex)
              _this.myCardSwitch(this.activeIndex)
            },
            slideChangeTransitionStart: function() {}
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        },
        fl_final_cut:0,
        fl_final_price:0,
        current_card_price:0,
        popupShowCode:false,
        card_name:'',
        iphone:false,

        sq_is_show:false,

        bCouponPrice:18888
      }
    },
    created() {},
    mounted() {
      var btn = document.getElementById('launch-btn');
      btn.addEventListener('launch', function (e) {
        console.log('success');
      });
      btn.addEventListener('error', function (e) {
        console.log('fail', e.detail);
      });

      this.phoneSystem()
      if(sessionStorage.getItem('fl_protol_agree')){
        this.vip_protol_agree=true
        this.vip_scroll_bottom=true
        this.vip_protol_agree_icon=this.vip_protol_agree_yes
      }else{
        this.vip_protol_agree_icon=this.vip_protol_agree_no
      }
      if(sessionStorage.getItem('fl_protol_agreeB')){
        this.vip_protol_agreeB=true
        this.vip_protol_agree_iconB=this.vip_protol_agree_yes
        this.vip_protol_agree_iconB=this.vip_protol_agree_yes
      }else{
        this.vip_protol_agree_iconB=this.vip_protol_agree_no
      }
      // vip_protol_agree_iconB
      this.isViper()
      this.phoneSystemM()

      if(new Date().getTime() >= new Date('2021/04/09').getTime()){
        console.log('活动已结束')

      }else{
        console.log('活动未结束')
        this.bCouponPrice=18000
      }
    },
    methods: {

      sq(){
        console.log(new Date().getTime())
        if(new Date().getTime() >= new Date('2021/04/09').getTime()){
          console.log('活动已结束')
          this.sq_is_show=false
          // return
        }else{
          console.log('活动进行中')
          this.sq_is_show=true
          // return
        }
      },
      // 运行环境
      phoneSystemM(){
        var u = navigator.userAgent;
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        // alert(1)
        if(isIOS){
          this.iphone=true
        }else{
          this.iphone=false
        }
      },
      // 判断是否存在有效会员卡
      isViper(){
        var $this = this
        console.log($this.$store.state.array_mycard)
        let param = {
          token: localStorage.getItem("token")
        }
        var qs = require('qs');
        let url = this.api.userApi.flUserCardsList
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          if (result.code==0) {
            console.log(result)
            if(result.data&&result.data.length>0){
              var arrsas=[]
              for (var i = 0; i < result.data.length; i++) {
                if(result.data[i].vip_tag=="A1"||result.data[i].vip_tag=="A2"||result.data[i].vip_tag=="B1"||result.data[i].vip_tag=="B2"||result.data[i].vip_tag=="C1"||result.data[i].vip_tag=="C2"){
                  arrsas.push(result.data[i])
                }
              }
              if(arrsas.length>0){
                console.log('有会员卡')
                $this.viper=1
                $this.flswiper=arrsas
                $this.myCardSwitch(0)
                $this.loaded=true
              }else{
                $this.viper=0
                $this.getViperCoupon()
              }

            }else{
              console.log('无会员卡')
              $this.viper=0
              $this.getViperCoupon()
              // $this.loaded=true
            }
            $this.sq()
          } else {
            $this.$toast(result.msg)
            console.log('无会员卡')
            $this.viper=0
            $this.getViperCoupon()
            $this.sq()
            // $this.loaded=true
          }
        }).catch((error) => {
          // console.warn(error)
        })

        return
        if($this.$store.state.array_mycard.length==0){
          // console.log(1)

        }else{
          console.log('有会员卡')
          $this.viper=1
          console.log($this.$store.state.array_mycard)
          $this.flswiper=$this.$store.state.array_mycard
          console.log($this.$store.state.array_mycard[0])
          $this.myCardSwitch(0)
          $this.loaded=true
        }
      },
      /**
       * 无卡状态
       */
      // 无卡状态：切换不同的卡
      VipUnSelect(item){
        this.vip_un_curCard=item
        this.FLCutPrice()
      },
      // 判断是否为 iphone 长屏手机
      isIphoneX() {
        return /iphone/gi.test(navigator.userAgent) && (screen.height >800 && screen.width == 375)
      },
      phoneSystem(){
        var u = navigator.userAgent;
        var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if(screen.height >800 &&isIOS){
          this.isphone=true
        }else{
          this.isphone=false
        }
      },
      // 关闭弹框
      VIPClosePopup(){
        this.popupShow=false
      },
      VIPClosePopupB(){
        this.popupShowB=false
      },
      // 同意购买协议
      VIPAgreeProtol(){
        if(this.vip_scroll_bottom==true){
          // this.fl_protol_agree_icon=this.fl_protol_agree_yes
          this.popupShow=false
          this.vip_protol_agree=true
          this.vip_protol_agree_icon=this.vip_protol_agree_yes
          sessionStorage.setItem('fl_protol_agree','true')
        }
      },
      VIPAgreeProtolB(){
        console.log('同意黑金')
        if(this.vip_scroll_bottomB==true){
          this.popupShowB=false
          this.vip_protol_agreeB=true
          this.vip_protol_agree_iconB=this.vip_protol_agree_yes
          sessionStorage.setItem('fl_protol_agreeB','true')
        }
      },
      // 购卡协议滚动条
      FLScrollEvent(e){
        if (e.srcElement.scrollTop + e.srcElement.clientHeight + 20 >= e.srcElement.scrollHeight ) {
          this.vip_scroll_bottom=true
        }
      },
      FLScrollEventB(e){
        if (e.srcElement.scrollTop + e.srcElement.clientHeight + 20 >= e.srcElement.scrollHeight ) {
          this.vip_scroll_bottomB=true
        }
      },
      // 阅读斐燃会员
      VipReadProtol(){
        this.popupShow=true
      },
      VipReadProtolB(){
        this.popupShowB=true
      },
      // 获取我的优惠券
      getViperCoupon(){
        var $this = this
        $this.coupon_list=[]
        let param = {
          token: localStorage.getItem("token"),
          page: 1,
          offset: 100,
          type: 1,
          consum_rule: 1,
          status: 1
        }
        var qs = require('qs');
        let url = this.api.userApi.getCouponList
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // // console.log(result)
          if (result.code == 0) {
            if (result.data.coupons.data.length > 0) {
              /**
                优惠券类型区分：
                  consum_limit  1卖卡  2预约  3全部
                  coupon_type 1代金券  2 折扣 3满减 4 抵用 【1amount  2discount  3full amount  4只能预约】
                  type 1自用  2邀约
                  status 1 正常 2已使用 3已作废 4已过期 5已赠送
                */
              for (var i = 0; i < result.data.coupons.data.length; i++) {
                if(result.data.coupons.data[i].consum_limit==1||result.data.coupons.data[i].consum_limit==3){
                  if(result.data.coupons.data[i].info.coupon_type==1||result.data.coupons.data[i].info.coupon_type==2||result.data.coupons.data[i].info.coupon_type==3){

                    // // console.log(result.data.coupons.data[i].start_date)
                    // // console.log()
                    if(new Date((result.data.coupons.data[i].start_date).replace(/-/g,'/')).getTime()<=new Date().getTime()){
                      $this.coupon_list.push(result.data.coupons.data[i])
                    }
                  }
                }
              }
            }
            // // // console.log($this.coupon_list)
            $this.FLCutPrice()

          } else {
            $this.$toast(result.msg)
          }
        }).catch((error) => {
          // // console.warn(error)
        })
      },
      // 判断是否有优惠
      FLCutPrice(){

        if(this.coupon_list.length>0){
          console.log('有优惠额度')
          // this.vip_un_curCard
          var current_card_price=0
          if(this.vip_un_curCard=='A'){
            current_card_price=288
          }else if(this.vip_un_curCard=='B'){
            current_card_price=1188
          }else if(this.vip_un_curCard=='C'){
            current_card_price=3888
          }else{
            current_card_price=18888
          }
          this.current_card_price=current_card_price
          // this.fl_cutprice=true
          // // console.log(this.coupon_list)
          // // // console.log(this.current_card.price)
          var fl_final_price=parseFloat(current_card_price,10)
          var fl_final_cut=0
          /**
            优惠券类型区分：
              consum_limit  1卖卡  2预约  3全部
              coupon_type 1代金券  2 折扣 3满减 4 抵用 【1amount  2discount  3full amount  4只能预约】
              type 1自用  2邀约
              status 1 正常 2已使用 3已作废 4已过期 5已赠送
            */

          var cutarr=[]
          for (var i = 0; i < this.coupon_list.length; i++) {
            if(this.coupon_list[i].info.coupon_type==1){
              // // console.log((parseFloat(this.current_card.price,10) - parseFloat(this.coupon_list[i].info.amount,10)).toFixed(2))
              var p=(parseFloat(current_card_price,10) - parseFloat(this.coupon_list[i].info.amount,10)).toFixed(2)
              p=parseFloat(p,10)
              cutarr.push(p)
            }else if(this.coupon_list[i].info.coupon_type==2){
              // // console.log((parseFloat(this.current_card.price,10) * parseFloat(this.coupon_list[i].info.discount,10)).toFixed(2))
              var p=(parseFloat(current_card_price,10) * parseFloat(this.coupon_list[i].info.discount,10)).toFixed(2)
              p=parseFloat(p,10)
              cutarr.push(p)
            }else if(this.coupon_list[i].info.coupon_type==3){
              if(parseFloat(current_card_price,10)>=parseFloat(this.coupon_list[i].info.full,10)){

                // // console.log(this.current_card.price)
                // // console.log(this.coupon_list[i].info.amount)

                // // console.log((parseFloat(this.current_card.price,10) - parseFloat(this.coupon_list[i].info.amount,10)).toFixed(2))
                var p=(parseFloat(current_card_price,10) - parseFloat(this.coupon_list[i].info.amount,10)).toFixed(2)
                p=parseFloat(p,10)
                // // console.log(p)
                cutarr.push(p)
              }else{
                // // console.log((parseFloat(this.current_card.price,10)).toFixed(2))
                var p=(parseFloat(current_card_price,10)).toFixed(2)
                p=parseFloat(p,10)
                cutarr.push(p)
              }
            }
          }
          console.log(cutarr)
          var sa=cutarr

          // var oMin=0;
          // var oMinIndex=0;
          // for(var i=0;i<cutarr.length; i++){
          //   if(cutarr[i]<oMin){
          //     oMin=cutarr[i]
          //     oMinIndex=i;
          //   }
          // }
          // // // console.log(oMinIndex)

          // // console.log(cutarr.slice(0).sort(function(a,b){return a-b}))
          // // console.log(cutarr.slice(0).sort(function(a,b){return a-b})[0])
          var curarr_pri=cutarr.slice(0).sort(function(a,b){return a-b})[0]
          for (var i = 0; i < sa.length; i++) {
            if(sa[i]==curarr_pri){
              // // console.log(i)
              // // console.log(this.coupon_list[i])
              this.user_coupon_id=this.coupon_list[i].id
              break
            }
          }
          fl_final_price=curarr_pri
          fl_final_cut= parseFloat(current_card_price,10) - curarr_pri
          // .slice(0).sort(function(a,b){return a-b})[0];

          // for (var i = 0; i < this.coupon_list.length; i++) {
          //   // // console.log(this.coupon_list[i].info.amount)
          //   if(fl_final_price>0){
          //     fl_final_price=fl_final_price-parseFloat(this.coupon_list[i].info.amount,10)
          //     fl_final_cut=fl_final_cut+parseFloat(this.coupon_list[i].info.amount,10)
          //   }else{
          //     break
          //   }
          // }
          if(fl_final_price<0){
            fl_final_price=0
          }
          console.log(fl_final_price)
          console.log(fl_final_cut)
          this.fl_final_price=fl_final_price
          this.fl_final_cut=fl_final_cut
        }else{
          // this.fl_cutprice=false
          console.log('无优惠额度')
          this.user_coupon_id=''

          var current_card_price=0
          if(this.vip_un_curCard=='A'){
            current_card_price=288
          }else if(this.vip_un_curCard=='B'){
            current_card_price=1188
          }else if(this.vip_un_curCard=='C'){
            current_card_price=3888
          }else{
            current_card_price=18888
          }

          this.fl_final_price=current_card_price
          this.fl_final_cut=0
          this.current_card_price=current_card_price
        }
        this.loaded=true
        // this.fl_price_load=true
      },
      // 购卡
      BuyCard(){
        var $this=this
        if(this.vip_protol_agree==false){
          this.$toast('请先阅读并同意《斐燃会员开通协议》');
          setTimeout(function(){
            $this.VipReadProtol()
          },1000)
          return
        }
        console.log(this.coupon_list)
        console.log(this.vip_un_curCard)
        console.log(this.user_coupon_id)


        $this.$loading('正在购卡');
        // // console.log(this.current_card)
        let param = {
          token: localStorage.getItem("token"),
          type:this.vip_un_curCard,
          user_coupon_id:this.user_coupon_id
        }
        var qs = require('qs');
        let url = this.api.userApi.flBuyCardsV2
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {

          if (!result.data) {
            $this.$loading.close()
            $this.$toast(result.msg);

          } else {
            if (result.data.pay_json) {
              let config = JSON.parse(result.data.pay_json);
              if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                  document.addEventListener('WeixinJSBridgeReady', $this.onBridgeReady(config, result.data.order_no),
                    false);
                } else if (document.attachEvent) {
                  document.attachEvent('WeixinJSBridgeReady', $this.onBridgeReady(config, result.data.order_no));
                  document.attachEvent('onWeixinJSBridgeReady', $this.onBridgeReady(config, result.data.order_no));
                }
              } else {
                $this.onBridgeReady(config, result.data.order_no);
              }
            } else {
              $this.$store.commit('updataMycard', [])
              $this.$loading.close()
              setTimeout(function() {
                $this.$router.push({
                  name: 'vipsuccess',
                  params: {
                    order_no: result.data.order_no
                  }
                })
              }, 500)
            }
          }
        }).catch((error) => {
          console.warn(error)
        })


      },
      // 支付金额
      onBridgeReady(config, order_no) {
        var $this = this
        WeixinJSBridge.invoke(
        'getBrandWCPayRequest', config,
        function(res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            $this.$store.commit('updataMycard', [])
            $this.$loading.close()
            $this.$router.push({
              name: 'vipsuccess',
              params: {
                order_no: order_no
              }
            });
          } else {
            $this.$loading.close()
            $this.$toast("支付失败,请重新支付");
          }
        });
      },
      /**
       * 有卡状态
       */
      // 切换我的会员卡
      myCardSwitch(item){
        var $this=this
        $this.viper_index=item
        console.log($this.flswiper[item])
        $this.viper_current_obj=$this.flswiper[item]
        // console.log($this.flswiper[item].vip_tag)
        if($this.flswiper[item].vip_tag=='A1'||$this.flswiper[item].vip_tag=='A2'){
          this.card_name='黄金'
        }else if($this.flswiper[item].vip_tag=='B1'||$this.flswiper[item].vip_tag=='B2'){
          this.card_name='铂金'
        }else if($this.flswiper[item].vip_tag=='C1'||$this.flswiper[item].vip_tag=='C2'){
          this.card_name='钻石'
        }else{
          this.card_name=$this.flswiper[item].name
        }
      },
      // 去预约
      tostadiumlist(item){
        this.showVipBenefit(5,'fit')
        return
        if(item==0){
          this.showVipBenefit(5,'fit')
        }else{
          this.$router.push({
            name:'allstadium',
            params:{
              type:'1'
            }
          })
        }
      },
      tostadiumlistm(){
        this.$router.push({
          name:'reserve'
        })
      },
      // 权益适用明细
      toVipBenefitLog(){
        var $this=this
        // console.log($this.flswiper[$this.viper_index])
        var param={
          cards_no:$this.flswiper[$this.viper_index].cards_no,
          free_times:$this.flswiper[$this.viper_index].free_times
        }
        this.$router.push({
          name:'freebenefittime',
          params:param
        })
      },
      hotLine(){
        window.location.href = "tel:400-630-5888"
      },
      // 客服咨询
      qimoCustomer(){
        window.qimoChatClick()
      },
      qushenquan(){
        this.$router.push({
          name:'acfour'
        })
      },
      // 黑金购卡
      BuyCardBlack(){
        console.log('点击黑金购卡')
      },
      // 会员使用细则
      viperUserRules(){
        this.$router.push({
          name:'useRules'
        })
      },
      // 展示黑金二维码
      showBlackCode(){
        var $this=this
        if(this.vip_protol_agreeB==false){
          this.$toast('请先阅读并同意《斐燃黑金会员开通协议》');
          setTimeout(function(){
            $this.VipReadProtolB()
          },1000)
          return
        }
        this.popupShowCode=true
      },
      // 掐网权益明细
      showVipBenefit(e,stype){
        console.log(this.viper_current_obj)
        //
        var disc=''
        if(this.viper_current_obj.vip_tag=='A1'||this.viper_current_obj.vip_tag=='B1'||this.viper_current_obj.vip_tag=='C1'){
          disc='a1'
        }else{
          disc='a2'
        }

        var type = 0; //3：钻石会员；2、铂金卡；1、金卡
        if(this.viper_current_obj.vip_tag=='A1'||this.viper_current_obj.vip_tag=='A2'){
          type=1
        }else if(this.viper_current_obj.vip_tag=='B1'||this.viper_current_obj.vip_tag=='B2'){
          type=2
        }else{
          type=3
        }

        this.$router.push({
          name: 'vipbenefit',
          params: {
            type: type,
            card_no: 'no',
            active:e,
            disc:disc,
            stype:stype
          }
        })

      },
      toallstadiumlist(item){
        console.log(item)
        this.$router.push({
          name:'allstadium',
          params:{
            type:item
          }
        })
      },
      showCradUseRule(){
        this.$router.push({
          name:'useRules'
        })
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  // 无会员卡状态
  .vip_un{
    width: 100%;
    background: #FFFFFF;
  }
  .vip_top{
    width: 100%;
  }
  .vip_tabs{
    width: 100%;
    height: 340*@vm_base;
    background: linear-gradient(150deg, #0A0A0A 0%, #4B3D31 100%);
    padding: 60*@vm_base 40*@vm_base 0 40*@vm_base;
    position: relative;
    .vip_tabs_title{
      width: 100%;
      font-size: 44*@vm_base;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 1;
    }
    .vip_tabs_stitle{
      width: 100%;
      font-size: 24*@vm_base;
      font-weight: 400;
      color: #CCCCCC;
      margin-top: 24*@vm_base;
      display: flex;
      align-items: center;
      img{
        height: 28*@vm_base;
        margin-left: 0*@vm_base;
      }
    }
    .vip_tabs_list{
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 0;
      z-index: 2;
      height: 120*@vm_base;
      padding: 0 30*@vm_base 0 40*@vm_base;
      white-space: nowrap;
      .vip_tabs_item{
        width: calc(25% - 10*@vm_base);
        height: 120*@vm_base;
        border-radius: 4*@vm_base 4*@vm_base 0 0;
        float: left;
        margin-right: 10*@vm_base;
        position: relative;
        .vip_tabs_item_title{
          width: 100%;
          font-size: 30*@vm_base;
          font-weight: 500;
          line-height: 1;
          text-align: center;
          margin: 26*@vm_base 0 0 0;
        }
        .vip_tabs_item_stitle{
          width: 100%;
          font-size: 30*@vm_base;
          font-weight: 500;
          line-height: 1;
          text-align: center;
          margin: 12*@vm_base 0;
        }
        .vip_tabs_item_limite{
          position: absolute;
          top: 0;
          right: 0;
          font-size: 18*@vm_base;
          font-weight: 400;
          color: #EFEEEE;
          padding: 3*@vm_base 7*@vm_base 0 7*@vm_base;
          background: #161616;
          margin-top: -18*@vm_base;
        }
      }
      .vip_tabs_itemS{
        height: 160*@vm_base;
        border-radius: 4*@vm_base;
      }
      .vip_tabs_item_A{
        background: linear-gradient(180deg, #FBEABF 0%, #DFBA82 100%);
        .vip_tabs_item_title{
          color: #684609;
        }
        .vip_tabs_item_stitle{
          color: #684609;
        }
        .vip_tabs_item_current{
          width: 80*@vm_base;
          text-align: center;
          background: rgba(0, 0, 0, 0.3);
          border-radius: 15*@vm_base;
          text-align: center;
          padding: 2*@vm_base 0;
          font-size: 18*@vm_base;
          font-weight: 400;
          color: #F1F1F1;
          margin-left: calc(50% - 40*@vm_base);
        }
      }
      .vip_tabs_item_B{
        background: linear-gradient(180deg, #F7DDD0 0%, #D6AB93 100%);
        .vip_tabs_item_title{
          color: #663226;
        }
        .vip_tabs_item_stitle{
          color: #663226;
        }
        .vip_tabs_item_current{
          width: 80*@vm_base;
          text-align: center;
          background: rgba(0, 0, 0, 0.3);
          border-radius: 15*@vm_base;
          text-align: center;
          padding: 2*@vm_base 0;
          font-size: 18*@vm_base;
          font-weight: 400;
          color: #F1F1F1;
          margin-left: calc(50% - 40*@vm_base);
        }
      }
      .vip_tabs_item_C{
        background: linear-gradient(180deg, #F7F7F7 0%, #B0B0B0 100%);
        .vip_tabs_item_title{
          color: #222222;
        }
        .vip_tabs_item_stitle{
          color: #222222;
        }
        .vip_tabs_item_current{
          width: 80*@vm_base;
          text-align: center;
          background: rgba(0, 0, 0, 0.3);
          border-radius: 15*@vm_base;
          text-align: center;
          padding: 2*@vm_base 0;
          font-size: 18*@vm_base;
          font-weight: 400;
          color: #F1F1F1;
          margin-left: calc(50% - 40*@vm_base);
        }
      }
      .vip_tabs_item_D{
        background: linear-gradient(180deg, #393939 0%, #0D0D0D 100%);
        .vip_tabs_item_title{
          color: #FFF4C4;
        }
        .vip_tabs_item_stitle{
          color: #FFF4C4;
        }
        .vip_tabs_item_current{
          width: 80*@vm_base;
          text-align: center;
          background: rgba(255, 255, 255, 0.3);
          border-radius: 15*@vm_base;
          text-align: center;
          padding: 2*@vm_base 0;
          font-size: 18*@vm_base;
          font-weight: 400;
          color: #F1F1F1;
          margin-left: calc(50% - 40*@vm_base);
        }
      }
    }
  }
  .vip_desc{
    padding: 0 40*@vm_base;
    position: relative;
    .vip_desc_img{
      width: 100%;
    }
    .vip_desc_txt{
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      width: 100%;
      padding: 60*@vm_base 40*@vm_base 0 80*@vm_base;

      .vip_desc_txt_blackicon{
        position: absolute;
        top: 0;
        left: 0;
        width: 174*@vm_base;
        z-index: 2;
        margin-left: 80*@vm_base;
        margin-top: 30*@vm_base;
      }
      .vip_desc_txt_title{
        width: 100%;
        font-size: 40*@vm_base;
        font-weight: 500;
        color: #684609;
        // line-height: 1.4;
        // letter-spacing: 1px;
        white-space: nowrap;
        .vip_desc_txt_titleL{
          font-size: 60*@vm_base;
          line-height: 1.4;
          font-weight: bolder;
        }
        .vip_desc_txt_titleLB{
          font-size: 60*@vm_base;
          line-height: 1.4;
          font-weight: 500;
        }
        .vip_desc_txt_titleN{
          color: #FF3030;
          font-weight: 700;
        }
      }
      .vip_desc_txt_stitle{
        width: 100%;
        font-size: 24*@vm_base;
        font-weight: 500;
        color: #A5865F;
        line-height: 1;
        margin-top: 32*@vm_base;
        margin-bottom: 12*@vm_base;
        label{
          color: #FF3030;
          font-weight: 700;
        }
      }
      .vip_desc_txt_stitles{
        width: 100%;
        font-size: 24*@vm_base;
        font-weight: 400;
        color: #A5865F;
        // line-height: 1.375;
        label{
          font-size: 28*@vm_base;
          line-height: 1.375;
          font-weight: 700;
        }
      }
    }
  }
  .vip_tb{
    width: 100%;
    padding: 68*@vm_base 40*@vm_base 164*@vm_base 40*@vm_base;
    .vip_tb_title{
      width: 100%;
      font-size: 32*@vm_base;
      font-weight: 500;
      color: #000000;
      line-height: 1.4;
      text-align: center;
      padding-bottom: 40*@vm_base;
      label{
        width: 200*@vm_base;
        height: 2*@vm_base;
        background: #EDE7E1;
        margin-top: 22*@vm_base;
      }
      .vip_tb_title_left{
        float: left;

      }
      .vip_tb_title_right{
        float: right;
      }
    }
    .vip_tb_item{
      width: 100%;
      padding-bottom: 60*@vm_base;
      .vip_tb_item_title{
        width: 100%;
        font-size: 24*@vm_base;
        font-weight: 500;
        color: #1D1F26;
        line-height: 1;
        padding-left: 34*@vm_base;
        background-image: url(../../assets/images/fl20210204/vipmodify.png);
        background-size: 18*@vm_base 24*@vm_base;
        background-repeat: no-repeat;
        background-position: left center;
      }
      .vip_tb_item_block{
        margin: 30*@vm_base 0 0 0;
        padding: 0;
        width: calc(100% - 5*@vm_base);
        // border-right: 1*@vm_base solid #E7E7E7;
        // border: 1*@vm_base solid red;
        // border-top: 1*@vm_base solid #E7E7E7;
        // border-right: 1*@vm_base solid #E7E7E7;
        // border-bottom: 1*@vm_base solid #E7E7E7;
        .vip_tb_item_block_item{
          width: calc(25% - 1*@vm_base);
          height: 113*@vm_base;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 24*@vm_base;
          font-weight: 400;
          color: #000000;
          line-height: 1.375;
          border-left: 1*@vm_base solid #E7E7E7;
          float: left;
          text-align: center;
          background: #FFFFFF;
          border-top: 1*@vm_base solid #E7E7E7;
          border-bottom: 1*@vm_base solid #E7E7E7;
        }
        .vip_tb_item_block_item_line{
          text-decoration: underline;
          color: #684609;
        }
        .vip_tb_item_block_itemF{
          width: calc(25% + 3*@vm_base);
          height: 113*@vm_base;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 24*@vm_base;
          font-weight: 400;
          // color: #000000;
          line-height: 1.375;
          border-left: 1*@vm_base solid #E7E7E7;
          float: left;
          text-align: center;
          background: #FFFFFF;
          border-top: 1*@vm_base solid #E7E7E7;
          border-bottom: 1*@vm_base solid #E7E7E7;
          border-right: 1*@vm_base solid #E7E7E7;
        }
        .vip_tb_item_block_itemA{
          background: #FEFAF3;
        }
        .vip_tb_item_block_itemB{
          background: #FDF7F4;
        }
        .vip_tb_item_block_itemC{
          background: #F5F5F5;
        }
        .vip_tb_item_block_itemD{
          background: #E6E6E6;
        }
      }
    }
  }
  .vip_buy{
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 9;
    width: 100%;
    height: 164*@vm_base;
    margin-bottom: 98*@vm_base;
    background: #FFFFFF;
    .vip_buy_protol{
      width: 100%;
      height: 54*@vm_base;
      background: #FFFFFF;
      box-shadow: 0 -2*@vm_base 10*@vm_base 0 rgba(165, 134, 95, 0.1);
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 24*@vm_base;
      // line-height: 94*@vm_base;
      // border: 1px solid red;
      font-weight: 400;
      color: #676460;
      label{
        text-decoration: underline;
      }
      img{
        width: 24*@vm_base;
        margin-right: 12*@vm_base;
        margin-top: -3*@vm_base;
      }
    }
    .vip_buy_btn{
      width: 100%;
      height: 110*@vm_base;
      background: linear-gradient(139deg, #0A0A0A 0%, #4B3D31 100%);
      font-size: 40*@vm_base;
      font-weight: 500;
      color: #FFFFFF;
      text-shadow: 0 2*@vm_base 10*@vm_base rgba(0, 0, 0, 0.1);
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      img{
        position: absolute;
        top: 0;
        left: 0;
        height: 110*@vm_base;
      }
      .vip_buy_btn_deleete{
        text-decoration: line-through;
        font-weight: 500;
        color: #8F8C98;
        // border: 1px solid red;
        line-height: 1;
        padding-top: 0;
        // line-height: 110*@vm_base;
        // padding-top: 18*@vm_base;
      }
      .vip_buy_btn_deleeteF{
        line-height: 3;
        // border: 1px solid blue;
        padding-top: 8*@vm_base;
      }
      .vip_buy_btn_price{
        // display: inline-block;
        font-weight: 500;
        color: #FFFFFF;
        // border: 1px solid red;
        // line-height: 110*@vm_base;
        line-height: 1;
        padding-top: 0;
        // padding-top: 8*@vm_base;
      }
      .vip_buy_btn_priceF{
        padding-top: 8*@vm_base;
      }
    }
    .vip_buy_btnB{
      width: 100%;
      height: 110*@vm_base;
      position: relative;
      background: linear-gradient(139deg, #0A0A0A 0%, #4B3D31 100%);
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 40*@vm_base;
      font-weight: 600;
      color: #FFFFFF;
      text-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
      .vip_buy_btnitem{
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999999999;
        width: 100%;
        height: 110*@vm_base;
      }
      .vip_buy_btnB_deleete{
        text-decoration: line-through;
        font-weight: 500;
        color: #8F8C98;
        // border: 1px solid red;
        line-height: 1;
        padding-top: 0;
        margin-right: 10*@vm_base;
        // line-height: 110*@vm_base;
        // padding-top: 18*@vm_base;
      }
      img{
        position: absolute;
        top: 0;
        left: 0;
        height: 110*@vm_base;
      }
    }
  }
  .vip_buyH{
    margin-bottom: 132*@vm_base;
  }
  // 有会员卡状态
  .vip_is{
    width: 100%;
  }
  .viper_title{
    width: 100%;
    padding: 60*@vm_base 60*@vm_base 40*@vm_base 60*@vm_base;
    font-size: 32*@vm_base;
    font-weight: 400;
    color: #333333;
  }
  .viper_swiper{
    width: 100%;
    .swiper-container {
      overflow: visible;
    }
    .bb_vipBuyCard_swiper {
      width: 100%;
      .bb_vipBuyCard_swiper_slide {
        width: 84%;
        .bb_vipBuyCard_swiper_slide_cardbg {
          box-shadow: 0px 10*@vm_base 10*@vm_base 0px #c7c6ca;
          border-radius: 12*@vm_base;
        }
        img {
          width: 100%;
        }
        .bb_viptem_saleover {
          position: absolute;
          top: 0;
          left: 0;
          width: 96*@vm_base;
        }
        .bb_viptem_num {
          position: absolute;
          bottom: 0;
          left: 0;
          color: rgba(255, 255, 255, 0.4);
          font-size: 24*@vm_base;
          padding-bottom: 50*@vm_base;
          padding-left: 60*@vm_base;
        }
      }
    }
    .swiper-button-next {
      position: absolute;
      top: 0;
      right: 0;

      width: 100*@vm_base;
      height: 100*@vm_base;
      background-image: url(../../assets/images/base/arrows_card_rightbc.png);
      background-size: 100*@vm_base auto;
      background-position: center;
      background-repeat: no-repeat;
      border: none;
      outline: none;
      // margin-right: -32*@vm_base;
      margin-top: 270*@vm_base;
      // border: 1px solid red;
    }
    .swiper-button-next::after {
      content: '';
    }
    .swiper-button-prev {
      position: absolute;
      top: 0;
      left: 0;
      width: 100*@vm_base;
      height: 100*@vm_base;
      background-image: url(../../assets/images/base/arrows_card_leftbc.png);
      background-size: 100*@vm_base auto;
      background-position: center;
      background-repeat: no-repeat;
      border: none;
      outline: none;
      // margin-left: -32*@vm_base;
      margin-top: 270*@vm_base;
      // border: 1px solid red;
    }
    .swiper-button-prev::after {
      content: '';
    }
    .swiper-slide-prev {
      img {
        transition: all .25s ease-in;
        transform: scale(0.911, 0.847);
      }
      .fl_cupanel{
        transition: all .25s ease-in;
        transform: scale(0.911, 0.847);
      }
    }
    .swiper-slide-next {
      img {
        transition: all .25s ease-in;
        transform: scale(0.911, 0.847);
      }
      .fl_cupanel{
        transition: all .25s ease-in;
        transform: scale(0.911, 0.847);
      }

      .bb_viptem_saleover {
        margin-top: 20*@vm_base;
        margin-left: 23*@vm_base;
      }
    }
    .swiper-slide-active {
      img {
        transition: all .25s ease-in;
        transform: scale(1);
      }
    }
    .fl_cupanel{
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 0;
      // // border: 1px solid red;
      // .fl_cupanel_msg1{
      //   width: 100%;
      //   font-size: 28*@vm_base;
      //   font-weight: 400;
      //   color: #FFFFFF;
      //   line-height: 1;
      // }
      // .fl_cupanel_msg2{
      //   width: 100%;
      //   font-size: 24*@vm_base;
      //   font-weight: 400;
      //   color: rgba(255, 255, 255, 0.5);
      //   line-height: 1;
      //   margin-top: 24*@vm_base;
      //   div{
      //     float: right;
      //   }
      // }
      .fl_cupanel_msg3{
        width: 100%;
        font-size: 22*@vm_base;
        font-weight: 400;
        color: #80704F;
        padding: 0 36*@vm_base 40*@vm_base 36*@vm_base;
        font-weight: 500;
        div{
          float: right;
        }
      }
      .fl_cupanel_msg3A{
        color: #80704F;
      }
      .fl_cupanel_msg3B{
        color: #8D7C73;
      }
      .fl_cupanel_msg3C{
        color: #92908F;
      }
    }
  }
  .viper_line{
    width: 100%;
    margin-top: 60*@vm_base;
  }
  .viper_list{
    width: 100%;
    padding: 50*@vm_base 60*@vm_base 0 60*@vm_base;
    background: #FFFCF6;
    .viper_list_title{
      width: 100%;
      font-size: 32*@vm_base;
      font-weight: 500;
      color: #000000;
      // border: 1px solid red;
      div{
        font-size: 24*@vm_base;
        font-weight: 400;
        color: #999999;
        // line-height: 1.875;
        float: right;
        // border: 1px solid red;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 6*@vm_base;
        white-space: nowrap;
        // background-image: url(../../assets/images/fl20210204/vip_righrt_icon.png);
        // background-size: auto 28*@vm_base;
        // background-position: right center;
        // padding-right: 32*@vm_base;
        // background-repeat: no-repeat;
        .viper_list_title_icon1{
          height: 24*@vm_base;margin-right: 10*@vm_base;
        }
        .viper_list_title_icon2{
          height: 28*@vm_base;margin-right: 10*@vm_base;
        }
      }
    }
    .viper_list_block{
      width: 100%;
      padding: 40*@vm_base 0 44*@vm_base 0;
      .viper_list_itemL{
        width: calc(50% - 5*@vm_base);
        float: left;
        margin-right: 5*@vm_base;
        background: #F8EFD7;
        border-radius: 2*@vm_base;
        margin-bottom: 10*@vm_base;
        padding: 34*@vm_base 0 32*@vm_base 100*@vm_base;
        // border: 1px solid red;
      }
      .viper_list_itemR{
        width: calc(50% - 5*@vm_base);
        float: left;
        margin-left: 5*@vm_base;
        background: #F8EFD7;
        border-radius: 2*@vm_base;
        margin-bottom: 10*@vm_base;
        padding: 34*@vm_base 0 32*@vm_base 100*@vm_base;
      }
      .viper_list_item_title{
        width: 100%;
        font-size: 30*@vm_base;
        font-weight: 600;
        color: #333333;
        line-height: 1;
      }
      .viper_list_item_titles{
        color: #999999;
      }
      .viper_list_item_stitle{
        width: 100%;
        font-size: 24*@vm_base;
        font-weight: 400;
        color: #666666;
        line-height: 1;
        margin-top: 20*@vm_base;
        white-space: nowrap;
        label{
          // border: 1px solid red;
          display: inline-block;
          padding-right: 30*@vm_base;
          color: #A5865F;
          background-image: url(../../assets/images/fl20210204/viper_right.png);
          background-position: right -5*@vm_base;
          background-repeat: no-repeat;
          background-size: 30*@vm_base auto;
        }
      }
      .viper_list_item_stitleS{
        color: #aaaaaa;
      }
      .viper_list_hotline{
        width: 100%;
        text-align: center;
        font-size: 24*@vm_base;
        font-weight: 500;
        color: #666666;
        margin-top: 32*@vm_base;
        label{
          text-decoration: underline;
        }
      }
      .viper_list_icon1{
        background-image: url(../../assets/images/fl20210204/vip_free.png);
        background-size: 60*@vm_base auto;
        background-repeat: no-repeat;
        background-position: 20*@vm_base center;
      }
      .viper_list_icon2{
        background-image: url(../../assets/images/fl20210204/vip_member.png);
        background-size: 60*@vm_base auto;
        background-repeat: no-repeat;
        background-position: 20*@vm_base center;
      }
      .viper_list_icon3{
        background-image: url(../../assets/images/fl20210204/vip_birthday.png);
        background-size: 60*@vm_base auto;
        background-repeat: no-repeat;
        background-position: 20*@vm_base center;
      }
      .viper_list_icon4{
        background-image: url(../../assets/images/fl20210204/vip_hotels.png);
        background-size: 60*@vm_base auto;
        background-repeat: no-repeat;
        background-position: 20*@vm_base center;
      }
      .viper_list_icon5{
        background-image: url(../../assets/images/fl20210204/vip_swim.png);
        background-size: 60*@vm_base auto;
        background-repeat: no-repeat;
        background-position: 20*@vm_base center;
      }
      .viper_list_icon6{
        background-image: url(../../assets/images/fl20210204/vip_swim_unsubscribe.png);
        background-size: 60*@vm_base auto;
        background-repeat: no-repeat;
        background-position: 20*@vm_base center;
      }
      .viper_list_icon7{
        background-image: url(../../assets/images/fl20210204/vip_yoga.png);
        background-size: 60*@vm_base auto;
        background-repeat: no-repeat;
        background-position: 20*@vm_base center;
      }
    }
  }
  .viper_stper{
    width: 100%;
    background: #FFFCF6;
    padding: 20*@vm_base 40*@vm_base 130*@vm_base 40*@vm_base;
    img{
      width: 100%;
    }
    div{
      width: 100%;
      text-align: center;
      font-size: 24*@vm_base;
      font-weight: 500;
      color: #666666;
      text-decoration: underline;

    }
  }
  .viper_btn{
    position: fixed;
    bottom: 0;
    right: 0;
    width: 100%;
    background: linear-gradient(139deg, #0A0A0A 0%, #4B3D31 100%);
    padding: 25*@vm_base;
    z-index: 9;
    margin-bottom: 98*@vm_base;

    font-size: 40*@vm_base;
    text-align: center;
    font-weight: 500;
    color: #FFFFFF;
    text-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);

  }
  .viper_btnH{
    margin-bottom: 132*@vm_base;
  }
  // 客服咨询
  .vip_custom{
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 999;
    margin-bottom: 330*@vm_base;
    font-size: 22*@vm_base;
    font-weight: 400;
    color: #E1C786;
    background: #000000;
    box-shadow: 0 0 10*@vm_base 0 rgba(255, 255, 255, 0.1);
    border-radius: 48*@vm_base 0 0 48*@vm_base;
    padding: 20*@vm_base 12*@vm_base 20*@vm_base 72*@vm_base;
    background-image: url(../../assets/images/fl20210204/customerservice_online.png);
    background-size: 36*@vm_base;
    background-position: 24*@vm_base center;
    background-repeat: no-repeat;
  }
  .vip_customac{
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 999;
    margin-bottom: 460*@vm_base;
    font-size: 22*@vm_base;
    font-weight: 400;
    color: #E1C786;
    background: #000000;
    box-shadow: 0 0 10*@vm_base 0 rgba(255, 255, 255, 0.1);
    border-radius: 48*@vm_base 0 0 48*@vm_base;
    padding: 20*@vm_base 12*@vm_base 20*@vm_base 72*@vm_base;
    background-image: url(../../assets/images/fl20210204/customerservice_online.png);
    background-size: 36*@vm_base;
    background-position: 24*@vm_base center;
    background-repeat: no-repeat;
  }
  // 购买协议
  .vip_protol{
    width: 85vw;
    height: 69vh;
    background: #FFFFFF;
    border-radius: 24*@vm_base;
    padding: 80*@vm_base 40*@vm_base 40*@vm_base 40*@vm_base;
    position: relative;
    .vip_protol_title{
      width: 100%;
      font-size: 36*@vm_base;
      font-weight: 500;
      color: #000000;
      line-height: 1;
      text-align: center;
      padding-bottom: 40*@vm_base;
    }
    .vip_protol_conte{
      width: 100%;
      height: calc(69vh - 80*@vm_base - 36*@vm_base - 40*@vm_base - 80*@vm_base - 40*@vm_base - 40*@vm_base);
      overflow: hidden;
      overflow-y: auto;
      flex:1;
      font-size:26*@vm_base;
      font-weight:400;
      color:rgba(102,102,102,1);
      line-height:46*@vm_base;
      word-break: break-all;
      // border: 1px solid red;
      // &::-webkit-scrollbar{width:10px;height: 10px;background: red;}
      &::-webkit-scrollbar{width:10*@vm_base;}
      &::-webkit-scrollbar-thumb { //滑块部分
        border-radius: 12*@vm_base;
        background-color: #444054;
      }
      h1{
      	font-size:40*@vm_base;
      	font-weight:500;
      	color:rgba(51,51,51,1);
      	line-height:48*@vm_base;
      }
      h3{
      	margin-top:20*@vm_base;
      	margin-bottom:15*@vm_base;
      	font-size:30*@vm_base;
      	font-weight:500;
      	color:rgba(51,51,51,1);
      	line-height:52*@vm_base;
      }
    }
    .vip_protol_btn{
      width: 100%;
      line-height: 80*@vm_base;
      background: #F3F3F3;
      border-radius: 40*@vm_base;
      text-align: center;
      margin-top: 40*@vm_base;
      font-size: 32*@vm_base;
      font-weight: 500;
      color: #B4B3BB;
      letter-spacing: 2px;
    }
    .vip_protol_btnS{
      background: #444054;
      color: #FFFFFF;
    }
    .vip_protol_close{
      position: absolute;
      top: 0;
      right: 0;
      width: 60*@vm_base;
    }
  }
  // 黑金二维码弹框
  .vip_blackCode{
    width: 100%;
    padding: 70*@vm_base 20*@vm_base;
    border-radius: 30*@vm_base;
    background: none;
    // border: 1px solid red;
    img{
      width: 75%;
      // border-radius: 50%;
      margin: 0 auto;
    }
    div{
      width: 100%;
      text-align: center;
      margin-top: 30*@vm_base;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/vip/vip.vue